import { render } from "./DashboardMoneyballStick.vue?vue&type=template&id=b8f4fbd0"
import script from "./DashboardMoneyballStick.vue?vue&type=script&lang=js"
export * from "./DashboardMoneyballStick.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__